import { isEmpty, last } from 'lodash-es';
import formatDate from './formatDate';

const CHANGELOG_ACTIONS_MAP = {
  create: 'Created',
  update: 'Updated',
  delete: 'Deleted',
};

const splitCamelCase = (str = '') => {
  return str
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .replace(/([A-Z])([A-Z][a-z])/g, '$1 $2');
};

const getChangelogValue = (value) => {
  let newValue = value;
  if (Array.isArray(value) && !isEmpty(value)) {
    newValue = value.map((toItem) => `[${toItem.Key}: ${toItem.Value}] `);
  } else if (Array.isArray(value) && isEmpty(value)) {
    newValue = '[ ]';
  }
  return newValue || null;
};

const normalizeChangelog = (data = []) => {
  if (!data.length) {
    return [];
  }
  return data.map((item) => ({
    ...item,
    fieldName: splitCamelCase(last(item.field)),
    action: CHANGELOG_ACTIONS_MAP[item.action] || item.action,
    createdBy: item.actor,
    oldValue: getChangelogValue(item.from),
    newValue: getChangelogValue(item.to),
    shortName: item.actor?.slice(0, 2)?.toUpperCase(),
    date: item?.createdAt
      ? `${formatDate(item.createdAt, 'MMM d, yyyy')} at ${formatDate(
          item?.createdAt,
          'HH:mm'
        )}`
      : '',
  }));
};

export default normalizeChangelog;
